import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { UI_FLOW } from 'state/location/reducer';
import {Link} from 'react-router-dom';
import SetLocation from './SetLocation'
import {prettifyName} from '../util'

class DisplayLocation extends React.Component{

	render() {
		const {status, locale} = this.props.locale;
		return(
			<React.Fragment>
				Showing ballot info for {prettifyName(locale)}.<br/>
				<Link to='/election/'
					onClick={(e)=>{e.preventDefault(); this.context.store.dispatch({type:"LOCATION_STARTED"})}}>
					Change my location
				</Link>
				{
					status === UI_FLOW.PENDING && <SetLocation/>
				}
			</React.Fragment>
		)
	}
}


DisplayLocation.contextTypes = {
  store: PropTypes.object
};

function mapStateToProps(state) {
  const locale = state.locale;
  return { locale };
}

export default connect(mapStateToProps, {})(DisplayLocation);



// WEBPACK FOOTER //
// ./src/pages/june-5/components/DisplayLocation.js